"use client";
import React, { ReactNode, useEffect, useState } from "react";

import { MasonryHeader } from "./MasonryHeader";
import { MasonryBody } from "./MasonryBody";
import { MasonryFooter } from "./MasonryFooter";
import { twMerge } from "tailwind-merge";
import { MasonryColumns } from "@/shared/constants";

export interface Props {
  children: ReactNode;
  singleColumnList?: ReactNode;
  loading?: boolean;
  handleLoadMore: () => void;
  moreLabel?: string;
  columnsDisplay?: MasonryColumns;
  hasMore?: boolean;
  singleColumnClassName?: string;
  multiColumnClassName?: string;
  showHeader?: boolean;
}

function Masonry({
  children,
  singleColumnList,
  loading,
  handleLoadMore,
  moreLabel,
  columnsDisplay,
  hasMore,
  singleColumnClassName,
  multiColumnClassName,
  showHeader = true,
}: Props) {
  const [columns, setColumns] = useState(columnsDisplay ?? 3);
  const handleDisplayChange = (value: number) => {
    if (value < 1) setColumns(1);
    if (value > 3) setColumns(3);
    setColumns(value);
  };

  useEffect(() => {
    setColumns(columnsDisplay ?? 3);
  }, [columnsDisplay]);

  return (
    <div className="container mx-auto max-w-[1280px]">
      {showHeader && (
        <MasonryHeader
          currentDisplay={columns}
          onDisplayChange={handleDisplayChange}
        />
      )}
      <MasonryBody>
        <MasonryBody.SingleColumn
          className={twMerge(
            columns > 1 ? `md:hidden ${singleColumnClassName}` : "",
          )}
        >
          {singleColumnList}
        </MasonryBody.SingleColumn>
        <MasonryBody.MultiColumn
          columns={columns}
          loading={loading}
          className={twMerge(
            "hidden",
            columns > 1 ? `md:flex ${multiColumnClassName}` : "",
          )}
        >
          {children}
        </MasonryBody.MultiColumn>
      </MasonryBody>
      <MasonryFooter
        visible={hasMore}
        moreLabel={moreLabel}
        onLoadMore={handleLoadMore}
      />
    </div>
  );
}

export default Masonry;
